// extracted by mini-css-extract-plugin
module.exports = {"consumption-component":"consumption-component--2TPQK","text-figures":"text-figures--3wzHV","consumption-linechart":"consumption-linechart--3enyC"};